import { apiRequest } from "@/services/api-client";
import { UpdateItemDeckInput, UpdateItemDeckOutput, WebAppRoutes } from "types/web-app";

export const updateItemDeck = (input: UpdateItemDeckInput) =>
  apiRequest<UpdateItemDeckOutput>("/" + WebAppRoutes.UPDATE_ITEM_DECK, {
    method: "POST",
    body: JSON.stringify(input),
  });
